import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const Download = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DownloadOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;

  & a {
    cursor: pointer;
    text-decoration: none;
    display: flex;
  }
`;

export const ThemedDialog = styled(Dialog)`
  &.p-dialog {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(24, 24, 24, 0.22);
  }

  & .p-dialog-content,
  & .p-dialog-header {
    background: #ffffff;
  }

  & .p-dialog-header {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 12px 12px 0 0;
    border-bottom: none;
    background: transparent;
  }

  & .p-dialog-content {
    padding: 32px;
  }

  & .p-dialog-header-icons button {
    color: #5a5959;
    width: auto;
    height: auto;
    padding: 8px;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    margin: 0;

    &:hover {
      background: transparent;
    }

    &:focus,
    &:focus-visible {
      outline: none;
      box-shadow: none;
    }

    & svg {
      display: block;
    }
  }
`;

export const DialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const DialogTitle = styled.h2`
  margin: 0;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
`;

export const DialogText = styled.p`
  margin: 0;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
  max-width: 500px;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

const BaseDialogButton = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`;

export const SecondaryDialogButton = styled(BaseDialogButton)`
  border: 1.5px solid #065fa6;
  background: #ffffff;
  color: #065fa6;

  &:hover {
    border-color: #181818;
    color: #181818;
  }
`;

export const DangerDialogButton = styled(BaseDialogButton)`
  border: 1.5px solid #065fa6;
  background: #065fa6;
  color: #ffffff;

  &:hover {
    border-color: #181818;
    background: #181818;
  }
`;
